import FileService from '../../../../services/file_service';

const Images = (props) => {
  
    const getImageUrl = async (id) => {
      try {
        if (!id) return null;
        const blob = await FileService.getBadge(id);
        if (props.logout(blob)) return;
        if (!blob) return null;
        return URL.createObjectURL(blob);
      } catch (e) {
          if(e?.message != 'No existe un archivo cargado')
            props.message?.(e?.message || e, 'error');
      }
    };

    const updateImage = async (ex, id) => {
        const lostAccess = await props.losesAccess?.();
        if (lostAccess) return;
        const file = ex.target.files?.[0];
        if (!file) return;
        try {
          const fileUpdate = await FileService.uploadBadge(id, file);
          if (props.logout(fileUpdate)) return;
          props.message?.('Archivo cargado correctamente', 'success');
        } catch (e) {
          props.message((e?.message || e), "error");
        } finally {
          ex.target.value = '';
        }
      };

  return {
    getImageUrl,
    updateImage
  }  
}

export default Images;
